module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7774/images/default-avatar.png"